<template>
  <div style="overflow-y: auto">
    <loading :active.sync="loader" :can-cancel="false" :is-full-page="true"></loading>
    <b-row class="m-2">
      <b-col align="center">
        <p>Selecciona en el odontograma los dientes donde se colocará el trabajo</p>
      </b-col>
    </b-row>
    <b-row class="m-4">
      <p style="color: #60ADDC;">Ortodoncia y ortopedia</p>
    </b-row>
    <b-row>
      <b-col cols="4" >
        <OdontogramaOdt :disable="disable"
                        :dientesSeleccionados="dientesSeleccionados"
                        :multiplesDientesSeleccionados="multiplesDientesSeleccionados"
                        :multiplesODS="multiplesODS"
                        @dienteSeleccionado="dienteSeleccionado"
                        @multiplesODSeleccionado="multiplesODSeleccionado" />
      </b-col>
      <b-col align="left" class="mt-3" v-if="!otroElemento">
        <b-row style="height: 250px;">
          <b-col>
            <p>Elementos enviados a laboratorio<span style="color: red">*</span></p>
            <v-select
                v-model="objGuardar.elementos"
                placeholder="Selecciona uno o multiples elementos"
                id="idElemento"
                label="descripcion"
                required
                :options="listaElementosProps"
                :reduce="(variable) => variable.idElemento"
                multiple
            />
          </b-col>
          <b-col>
            <p>Aparatos<span style="color: red">*</span></p>
            <v-select
                v-model="objGuardar.aparatos"
                placeholder="Selecciona uno o multiples aparatos"
                id="idAparato"
                label="descripcion"
                required
                :options="listaAparatosProps"
                :reduce="(variable) => variable.idAparato"
                multiple
            />
          </b-col>
        </b-row>
        <b-row style="height: 250px;">
          <b-col>
            <p>Accesorios<span style="color: red">*</span></p>
            <v-select
                v-model="objGuardar.accesotios"
                placeholder="Selecciona uno o multiples accesorios"
                id="idAccesorio"
                label="descripcion"
                required
                :options="listaAccesoriosProps"
                :reduce="(variable) => variable.idAccesorio"
                multiple
            />
          </b-col>
          <b-col>
            <p>Colores<span style="color: red">*</span></p>
            <v-select
                v-model="objGuardar.colores"
                placeholder="Selecciona uno o multiples colores"
                id="idColor"
                label="nombre"
                required
                :options="listaColoresProps"
                :reduce="(variable) => variable.idColor"
                multiple
            />
          </b-col>
        </b-row>
        <b-row style="height: 250px;">
          <b-col cols="4">
            <p>Agregar imagenes</p>
            <br>
            <input type="file" ref="inputArchivosAdicionales" multiple @change="changeArchivosAdicionales($event)" style="display: none;">
            <b-button variant="outline-primary" class="rounded-pill" size="sm" @click="$refs.inputArchivosAdicionales.click()">
              Agregar archivos
            </b-button>

            <em class= "trash_svg btn-agregar-archivos-ad"
                v-b-tooltip.hover.topright.v-light
                title="Eliminar todos los archivos adicionales"
                v-if="objGuardar.listaArchivosGuardar.length > 0"
                @click="eliminarArchivosAdicionales()"
            ></em>
          </b-col>

          <b-col cols="4" v-if="objGuardar.listaArchivosGuardar.length > 0">
            <span class="textForm">Archivos cargados</span>
            <br>
            <div class="archivos-container">
              <div class="archivo-miniatura" v-for="(item, index) of objGuardar.listaArchivosGuardar" :key="index">
                <div class="logo-archivo">
                  <img src="../../../assets/laboratorio/pdf.svg" alt="logo-pdf-archivo">
                  <em v-if="!item.progreso" class="close_outline_svg" style="width: 14px; cursor: pointer; position: absolute; right: 7px;"
                      v-b-tooltip.hover.topleft.v-light
                      title="Eliminar"
                      @click="eliminarArchivo(index)"
                  ></em>

                  <!-- Mostrar spinner mientras se sube -->
                  <b-spinner small
                             v-else-if="item.progreso > 0 && item.progreso < 100"
                             style=" width: 14px; position: absolute; right: 7px;"
                  ></b-spinner>

                  <!-- Mostrar ícono de éxito si ya se subió -->
                  <em
                      v-else-if="item.progreso === 100"
                      class="check_green_svg"
                      style="width: 14px; position: absolute; right: 7px;"
                      v-b-tooltip.hover.topleft.v-light
                      title="Archivo subido con éxito"
                  ></em>

                </div>
                <div class="archivo-name">
                  <span style="font-size: xx-small">{{ item.nombreArchivo }}</span>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <p>Observaciones <span style="color: red">*</span></p>
            <b-form-textarea
                style="resize:both;"
                class="form-control form-control-sm"
                placeholder="Ingresa las observaciones"
                v-model="objGuardar.observaciones"
                type="text"
            ></b-form-textarea>
          </b-col>
        </b-row>
      </b-col>
      <b-col align="left" class="mt-3" v-else>
        <b-row style="height: 250px;">
          <b-col>
            <p>Elementos enviados a laboratorio<span style="color: red">*</span></p>
            <v-select
                v-model="objGuardar.elementos"
                placeholder="Selecciona uno o multiples elementos"
                id="idElemento"
                label="descripcion"
                required
                :options="listaElementosProps"
                :reduce="(variable) => variable.idElemento"
                multiple
            />
          </b-col>
          <b-col>
            <p>Especifique el elemento enviado</p>
            <b-form-input
                v-model="objGuardar.otroElemento"
                placeholder="Otro elemento que se envia"
                multiple
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row style="height: 250px;">
          <b-col>
            <p>Aparatos<span style="color: red">*</span></p>
            <v-select
                v-model="objGuardar.aparatos"
                placeholder="Selecciona uno o multiples aparatos"
                id="idAparato"
                label="descripcion"
                required
                :options="listaAparatosProps"
                :reduce="(variable) => variable.idAparato"
                multiple
            />
          </b-col>
          <b-col>
            <p>Accesorios<span style="color: red">*</span></p>
            <v-select
                v-model="objGuardar.accesotios"
                placeholder="Selecciona uno o multiples accesorios"
                id="idAccesorio"
                label="descripcion"
                required
                :options="listaAccesoriosProps"
                :reduce="(variable) => variable.idAccesorio"
                multiple
            />
          </b-col>
        </b-row>
        <b-row style="height: 250px;">
          <b-col cols="6">
            <p>Colores<span style="color: red">*</span></p>
            <v-select
                v-model="objGuardar.colores"
                placeholder="Selecciona uno o multiples colores"
                id="idColor"
                label="nombre"
                required
                :options="listaColoresProps"
                :reduce="(variable) => variable.idColor"
                multiple
            />
          </b-col>
          <b-col cols="4">
            <p>Agregar imagenes</p>
            <br>
            <input type="file" ref="inputArchivosAdicionales" multiple @change="changeArchivosAdicionales($event)" style="display: none;">
            <b-button variant="outline-primary" class="rounded-pill" size="sm" @click="$refs.inputArchivosAdicionales.click()">
              Agregar archivos
            </b-button>

            <em class= "trash_svg btn-agregar-archivos-ad"
                v-b-tooltip.hover.topright.v-light
                title="Eliminar todos los archivos adicionales"
                v-if="objGuardar.listaArchivosGuardar.length > 0"
                @click="eliminarArchivosAdicionales()"
            ></em>
          </b-col>

          <b-col cols="4" v-if="objGuardar.listaArchivosGuardar.length > 0">
            <span class="textForm">Archivos cargados</span>
            <br>
            <div class="archivos-container">
              <div class="archivo-miniatura" v-for="(item, index) of objGuardar.listaArchivosGuardar" :key="index">
                <div class="logo-archivo">
                  <img src="../../../assets/laboratorio/pdf.svg" alt="logo-pdf-archivo">
                  <em v-if="!item.progreso" class="close_outline_svg" style="width: 14px; cursor: pointer; position: absolute; right: 7px;"
                      v-b-tooltip.hover.topleft.v-light
                      title="Eliminar"
                      @click="eliminarArchivo(index)"
                  ></em>

                  <!-- Mostrar spinner mientras se sube -->
                  <b-spinner small
                             v-else-if="item.progreso > 0 && item.progreso < 100"
                             style=" width: 14px; position: absolute; right: 7px;"
                  ></b-spinner>

                  <!-- Mostrar ícono de éxito si ya se subió -->
                  <em
                      v-else-if="item.progreso === 100"
                      class="check_green_svg"
                      style="width: 14px; position: absolute; right: 7px;"
                      v-b-tooltip.hover.topleft.v-light
                      title="Archivo subido con éxito"
                  ></em>

                </div>
                <div class="archivo-name">
                  <span style="font-size: xx-small">{{ item.nombreArchivo }}</span>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <p>Observaciones<span style="color: red">*</span></p>
            <b-form-textarea
                style="resize:both;"
                class="form-control form-control-sm"
                placeholder="Ingresa las observaciones"
                v-model="objGuardar.observaciones"
                type="text"
            ></b-form-textarea>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <div class="text-center m-4">
      <b-button style="background: #1B81AF" variant="primary" pill size="sm" @click="finalizar()" :disabled="loader">
        <span>Finalizar</span>
        <b-spinner v-if="loader" variant="light" label="spinner" small></b-spinner>
      </b-button>
    </div>
  </div>
</template>
<script>
import OdontogramaOdt from "./OdontogramaOdt.vue";
import {S3Client} from "@aws-sdk/client-s3";
import {Upload} from "@aws-sdk/lib-storage";
import moment from "moment";
import {AwsService} from "@/apiServices/aws/AwsService";
export default {
  name: "OrtodonciaOrtopedia",
  components: {OdontogramaOdt},
  props: {
    datos: Object,
    listaElementosProps: Array,
    listaAparatosProps: Array,
    listaAccesoriosProps: Array,
    listaColoresProps: Array,
    ruta: String,
    idPaciente : Number,
    tipoFlujoFisico: Number,
    loader: Boolean,
  },
  data: () => ({
    dientesSeleccionados: [],
    multiplesDientesSeleccionados: [],
    multiplesODS: true,
    multiplesDientes: [],
    disable: false,
    dientes: [],
    objGuardar: {
      elementos: [],
      otroElemento: null,
      aparatos: [],
      accesotios: [],
      colores: [],
      observaciones: null,
      dientes: [],
      listaArchivosGuardar: [],
      tipoFlujoFisico: [],
    },
    hoy : null,
    awsServicio: new AwsService(),
    token: null,
    otroElemento: false,
  }),
  async created() {
    this.hoy = this.$moment().format("DD-MM-YYYY")
    this.idPaciente = this.$route.params.idPaciente;
    this.token = this.$localStorageService.getTokenAWS();
    await this.validarTokenAWS();
    this.objGuardar.tipoFlujoFisico = this.tipoFlujoFisico;
    this.datos.infoTratamiento.dientes.forEach(diente=>{
      this.dientesSeleccionados.push(diente);
    })
  },
  watch:{
    "datos.infoGeneral"(){
      this.datos.infoTratamiento.dientes.forEach(diente=>{
        this.dientesSeleccionados.push(diente);
      })
    },
    "objGuardar.elementos"(){
      let otro = false;
      this.objGuardar.elementos.forEach((guard)=>{
        if(guard === 5){
          otro = true;
        }
      })
      this.otroElemento = otro;
    }
  },
  methods: {
    multiplesODSeleccionado(data) {
      this.diente = data.diente;
      if (data.diente.idDiente != 137) {
        const i = this.objGuardar.dientes.map(d => d.idDiente).indexOf(this.diente.idDiente)
        console.log("i",i)
        if (i === -1) {
          this.objGuardar.dientes.unshift(this.diente);
        }else{
          const index = this.objGuardar.dientes.indexOf(this.diente);
          this.objGuardar.dientes.splice(index, 1);
          this.multiplesDientesSeleccionados = [];
        }
      }
    },
    dienteSeleccionado(data) {
      this.diente = data.diente;
      this.dientesSeleccionados = data.dientes;
      if (data.diente.idDiente != 137) {
        const i = this.objGuardar.dientes.map(d => d.idDiente).indexOf(this.diente.idDiente)
        if (i > -1) {
          this.$swal.fire({
            icon: "error",
            title: "<span style='font-size: medium'>upps, no se puede agregar otro \n padecimiento a este diente</span>",
            text: "pero no te preocupes, intenta con otro diente",
            customClass: {
              confirmButton: "text-small",
              content: "text-small",
            }
          });
          return;
        }
      }
      this.objGuardar.dientes.unshift(this.diente);
    },
    mostrarErrorLimite(mensajePersonalizado = null) {
      const mensaje = mensajePersonalizado || 'Ya has alcanzado el límite máximo de 5 archivos';

      this.$swal({
        icon: 'error',
        title: 'Límite de archivos',
        text: mensaje,
        confirmButtonText: 'Entendido'
      });
    },
    async changeArchivosAdicionales(e) {
      const MAX_ARCHIVOS = 5; // Define tu límite máximo
      const files = e.target.files || e.dataTransfer.files;

      // Validación estricta
      if (this.objGuardar.listaArchivosGuardar.length >= MAX_ARCHIVOS || this.objGuardar.listaArchivosGuardar.length === MAX_ARCHIVOS) {
        this.mostrarErrorLimite();
        e.target.value = '';
        return;
      }

      if (this.objGuardar.listaArchivosGuardar.length + files.length > MAX_ARCHIVOS) {
        this.mostrarErrorLimite(`Estás intentando subir ${files.length} archivos, pero solo puedes subir ${MAX_ARCHIVOS - this.objGuardar.listaArchivosGuardar.length} más`);
        e.target.value = '';
        return;
      }


      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const extension = file.name.split('.').pop().toLowerCase();
        const timestamp = this.$moment().format("YYYYMMDDHHmmssSSS");
        const nombreBase = 'ARCHIVO_AD'+ " " + timestamp; // Elimina la extensión

        this.objGuardar.listaArchivosGuardar.push({
          file: file,
          nombreArchivo: `${this.idPaciente}_${nombreBase}${i}.${extension}`,
          extension: extension,
          generadoEscaner: false,
        });
      }
      e.target.value = '';
    },

    eliminarArchivosAdicionales() {
      // Si no hay archivos adicionales
      if (this.objGuardar.listaArchivosGuardar.length === 0) {
        this.$swal({
          title: 'No hay archivos para eliminar',
          text: 'No se encontraron archivos adicionales',
          icon: 'info',
          timer: 1500
        });
        return;
      }

      // Confirmación
      this.$swal({
        title: '¿Eliminar todos los archivos?',
        html: `Estás por eliminar <b>${this.objGuardar.listaArchivosGuardar.length} archivo(s)</b>:<br>
           <ul class="text-left mt-2">
             ${this.objGuardar.listaArchivosGuardar.map(f => `<li>${f.nombreArchivo}</li>`).join('')}
           </ul>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar todos',
        cancelButtonText: 'Cancelar',
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$swal({
            title: 'Eliminados',
            html: `Se eliminaron ${this.objGuardar.listaArchivosGuardar.length} archivo(s)`,
            icon: 'success',
            timer: 3000
          });

          this.objGuardar.listaArchivosGuardar = [];
        }
      });
    },

    eliminarArchivo(index) {
      this.$swal({
        title: '¿Eliminar archivo?',
        text: `Estás por eliminar "${this.objGuardar.listaArchivosGuardar[index].nombreArchivo}"`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          // Elimina el archivo del array
          this.objGuardar.listaArchivosGuardar.splice(index, 1);

          this.$swal({
            title: 'Eliminado',
            text: 'El archivo ha sido removido',
            icon: 'success',
            timer: 1500
          });
        }
      });
    },

    async finalizar(){
      await this.guardarArchivos();
    },


    async guardarArchivos() {
      await this.validarTokenAWS();

      if (this.objGuardar.listaArchivosGuardar.length === 0) {
        this.$emit('finalizarOdt', this.objGuardar);
        return;
      }

      this.loaderArchivo = true;

      const client = new S3Client({
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      });

      let ruta = this.ruta.replace("#id_paciente", this.idPaciente.toString());
      let nombreCarpeta = `ODT ${this.hoy}`;

      try {
        for (const [index, archivo] of this.objGuardar.listaArchivosGuardar.entries()) {
          try {
            let tipoCarpeta = "ORTODONCIA Y ORTOPEDIA";

            let rutaDirectorio = `${ruta}/${nombreCarpeta}/${tipoCarpeta}`;
            let filePath = `${rutaDirectorio}/${archivo.nombreArchivo}`;

            this.objGuardar.listaArchivosGuardar[index].urlRuta = filePath;

            const input = {
              Bucket: this.token.nombreBucket,
              Key: filePath,
              Body: archivo.file,
              ContentType: archivo.file.type,
            };

            const upload = new Upload({
              client: client,
              params: input,
              partSize: 5 * 1024 * 1024,
              queueSize: 4,
            });

            upload.on("httpUploadProgress", (progress) => {
              const porcentaje = Math.round((progress.loaded / progress.total) * 100);
              this.$set(this.objGuardar.listaArchivosGuardar[index], "progreso", porcentaje);
            });

            await upload.done();

          } catch (error) {
            console.error(`Error al subir el archivo ${archivo.nombreArchivo}:`, error);
            throw error;
          }
        }

        this.$emit('finalizarOdt', this.objGuardar);

      } catch (error) {
        console.error("Error en el proceso:", error);

        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: `Hubo un problema: ${error.message}`,
        });
      } finally {
        this.loaderArchivo = false; // esto sí puedes mantener si quieres desactivar el loader
      }
    },

    async validarTokenAWS() {
      if (this.token !== null) {
        if (this.token.expireTo < moment(new Date()).format("YYYY-MM-DD HH:mm:ss")) {
          await this.awsServicio.obtenerTokenAcceso().then((response) => {
            this.token = response.data
            this.$localStorageService.setTokenAWS(this.token)
          })
        }else{
          if(typeof this.token === 'string'){
            this.token = JSON.parse(this.token);
          }
        }
      } else {
        await this.awsServicio.obtenerTokenAcceso().then((response) => {
          this.token = response.data
          this.$localStorageService.setTokenAWS(this.token)
        })
      }
    },

    reset(){
      this.objGuardar = {
        elementos: [],
        otroElemento: null,
        aparatos: [],
        accesotios: [],
        colores: [],
        observaciones: null,
        dientes: [],
        listaArchivosGuardar: [],
        tipoFlujoFisico: [],
      }
    }

  }
}
</script>

<style scoped>

.archivo-miniatura{
  width: 69px;
  min-height: 60px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.archivos-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.archivo-miniatura .logo-archivo{
  display: flex;
  justify-content: center;
}

.archivo-miniatura .archivo-name{
  font-size: xx-small;
  line-height: normal;
}

.textForm {
  font-size: 10px;
  text-align: left;
}

.btn-agregar-archivos-ad{
  margin-left: 10px;
  cursor: pointer;
  position: absolute;
  scale: 1.3;
  top: 65px;
}
</style>
